import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { PILL, Field, Input, TextareaField } from "./shared";

export default function SupportTab() {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [urgency, setUrgency] = useState("Normal");
  const [tickets, setTickets] = useState([]);
  const [sending, setSending] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/support"); setTickets(data); } catch { /* non-fatal */ }
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault(); setSending(true);
    try {
      await api.post("/support", { subject, message, urgency });
      setSubject(""); setMessage(""); setUrgency("Normal"); toast.success("Sent");
      load();
    } catch { toast.error("Failed"); }
    setSending(false);
  };

  return (
    <div>
      <div className="nb-card p-5 mb-6"><div className="font-display text-2xl font-extrabold">Support</div></div>
      <div className="grid md:grid-cols-[1fr_1fr] gap-4">
        <form onSubmit={submit} className="nb-card p-5 space-y-3" data-testid="support-form">
          <Field label="Subject"><Input value={subject} onChange={(e) => setSubject(e.target.value)} required testId="support-subject" /></Field>
          <Field label="Message"><TextareaField value={message} onChange={(e) => setMessage(e.target.value)} required testId="support-message" /></Field>
          <Field label="Urgency">
            <div className="flex gap-2">
              {["Low", "Normal", "High"].map((u) => (
                <button key={u} type="button" onClick={() => setUrgency(u)} data-testid={`urgency-${u}`}
                  className={`px-4 py-2 rounded-xl border-2 border-black font-semibold text-sm nb-press ${urgency === u ? "bg-[#111] text-white" : "bg-white"}`}>{u}</button>
              ))}
            </div>
          </Field>
          <button disabled={sending} className={`${PILL} bg-[#8B5CF6] text-white`} data-testid="support-send-btn">
            {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send"}
          </button>
        </form>
        <div className="space-y-3">
          {tickets.length === 0 && <div className="nb-card-flat p-5 text-sm text-gray-600">No tickets yet.</div>}
          {tickets.map((t) => (
            <div key={t.ticket_id} className="nb-card-flat p-4" data-testid={`ticket-${t.ticket_id}`}>
              <div className="flex items-center justify-between gap-3">
                <div className="font-bold">{t.subject}</div>
                <span className="px-2 py-1 text-xs rounded-full bg-[#F5F0FF] border border-black font-bold">{t.urgency}</span>
              </div>
              <p className="text-sm text-gray-700 mt-2">{t.message}</p>
              <div className="text-xs text-gray-500 mt-2">Status: {t.status}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
